// import 'react-app-polyfill/ie9'; // For IE 9-11 support
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './i18n';

import { store } from './redux/store';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Provider store={store}>
    <App />
</Provider>);
